import React from "react";

import BodyText from "Common/BodyText";
import { Card, CardHeader, CardSection } from "Common/Card";
import { Grid, Row, Col } from "Common/Grid";
import { usePartnerContext } from "Common/PartnerContext";

const EmailInUse = () => {
  const { partnerCasualName } = usePartnerContext();
  return (
    <div style={{ minHeight: "70vh" }}>
      <Grid componentClass={Card} mt={5}>
        <Row>
          <Col>
            <CardHeader>Email Already in Use</CardHeader>
            <CardSection>
              <BodyText>
                This email is already associated with an existing account.
                <br />
                If you want to log in through {partnerCasualName}, please verify your email on {partnerCasualName} first.
                <br />
                Otherwise please fillout our contact form{" "}
                <a href="https://support.simplyinsured.com/s/contactsupport" target="_blank" rel="noreferrer">
                  HERE
                </a>
                .
              </BodyText>
            </CardSection>
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default EmailInUse;
